import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { firmwareApi } from "@/api/firmware";

export function useFirmwareReleases(model?: string) {
  return useQuery({
    queryKey: ["firmware-releases", model ?? null],
    queryFn: () => firmwareApi.list(model),
  });
}

export function useSetFirmwarePublished() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ releaseId, isPublished }: { releaseId: string; isPublished: boolean }) =>
      firmwareApi.setPublished(releaseId, isPublished),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["firmware-releases"] });
    },
  });
}
